import { MapsHandler } from '../classes/MapsHandler';

window.addEventListener('DOMContentLoaded', () => {
    const mapsHandler = new MapsHandler();
    mapsHandler.init();
});
